import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import fr from './fr.json'
import en from './en.json'

export const resources = {
  fr: { translation: fr },
  en: { translation: en },
}

function resolveLanguage(fallback = 'en') {
  if (typeof window === 'undefined') return fallback
  const stored = window.localStorage.getItem('i18nextLng') || window.localStorage.getItem('v2_lang')
  const normalized = String(stored || '').slice(0, 2).toLowerCase()
  return normalized === 'fr' || normalized === 'en' ? normalized : fallback
}

function persistLanguage(language) {
  if (typeof window === 'undefined') return
  window.localStorage.setItem('i18nextLng', language)
  window.localStorage.setItem('v2_lang', language)
}

export function initI18n(lng = 'en') {
  const initial = resolveLanguage(lng)
  if (!i18n.isInitialized) {
    i18n.use(initReactI18next).init({
      resources,
      lng: initial,
      fallbackLng: 'en',
      interpolation: { escapeValue: false },
    })
    persistLanguage(initial)
    i18n.on('languageChanged', persistLanguage)
  }
  return i18n
}

export default i18n